<template>
    <v-layout align-center justify-center class="fill-height">
        <v-flex xs12 sm8 md4>
            <div class="text-center my-2">
				<v-img v-if="$vuetify.theme.dark" src="../assets/fps.png" height="150" contain />
                <v-img v-else src="../assets/fps.png" height="150" contain />
            </div>
            <v-form @submit.prevent="login">
                <v-card class="elevation-12">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>Login</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-text-field prepend-icon="mdi-email" name="login" label="Email" type="text" 
                            v-model="email" :disabled="loading"></v-text-field>
                        <v-text-field id="password" prepend-icon="mdi-lock" name="password" label="Password" 
                            type="password" v-model="password" :disabled="loading"></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn type="submit" color="primary" >Login</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
            <v-alert
                :value="error != null"
                v-if="!loading && error"
                type="error"
                class="mt-3 font-color"
                transition="scale-transition">{{ error }}</v-alert>
            <div class="text-center">
                <v-progress-circular
                    :class="{'hidden': !loading, 'visible': loading}"
                    indeterminate
                    align="center"
                    class="mt-3 mx-auto"
                    color="primary"
                ></v-progress-circular>
            </div>
        </v-flex>

        <v-footer app color="" class="justify-center">
            <span class="overline">Beetronix © All rights reserved — {{ new Date().getFullYear() }}</span>
        </v-footer>

		<v-snackbar v-model="snackbar" color='alert-color'>
			{{message}}
			<template v-slot:action="{ attrs }">
				<v-btn
					color="white"
					text
					v-bind="attrs"
					@click="snackbar = false"
				>
					Close
				</v-btn>
			</template>
		</v-snackbar>
    </v-layout>
</template>

<script>
// import { getError } from '../../helpers';
import { mapGetters, mapState } from 'vuex';

export default {
	data: () => ({
		email: null,
		password: null,

		loading: false,
		error: null,
		message: 'Incorrect username or password',
		snackbar: false
	}),

	methods: {
		login () {
			this.loading = true;
			this.$store.dispatch('auth/login', {
				email: this.email,
				password: this.password,
				username: this.email
			}).then((data) => {
				this.$store.dispatch('users/fetchById', { 
					id: data.id
				}).then(() => {
					this.$router.push({ name: 'home' })
				}).finally(() => {
					this.loading = false
				})
			}).catch(() => {
				this.snackbar = true
				this.loading = false
			})
		}
	},

	mounted () {
		if (this.authenticated) this.$router.push({ name: 'home' })
	},

	computed: {
		...mapGetters({
			isAuthenticated: 'auth/isAuthenticated'
		}),
		...mapState({
			authentication: state => state.auth.authentication
		})
	},
	created () {
		console.log(this.authentication)
	},

	meta: {
		title: 'Login'
	}
}
</script>
